import React, { useState, useMemo } from 'react';
import MediaCard from '../components/MediaCard';
import Lightbox from '../components/Lightbox';
import { useMedia } from '../hooks/useMedia';
import { PageHeader, EmptyChannel } from './Animation';
import { iconFor } from '../lib/icons';

const FILTERS = [
  { id: 'all', label: 'ALL' },
  { id: 'image', label: 'STILLS' },
  { id: 'video', label: 'MOTION' }
];

export default function VFX({ category, input, fallback }) {
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState('all');
  const { items: remote } = useMedia(category.key);
  const works = useMemo(() => (remote === null ? [] : remote.length ? remote : (fallback || [])), [remote, fallback]);
  const items = useMemo(() => filter === 'all' ? works : works.filter((w) => w.type === filter), [filter, works]);

  return (
    <div className="page-in w-full max-w-[1800px] mx-auto px-4 md:px-6 py-4 md:py-6 lg:py-8" data-testid={`page-${category.key}`}>
      <PageHeader input={input} title={category.name} icon={iconFor(category.icon)} />
      {remote && !works.length && <EmptyChannel />}

      <div className="flex gap-2 mb-5 flex-wrap">
        {FILTERS.map((f) => (
          <button key={f.id} onClick={() => setFilter(f.id)}
                  className={`font-osd text-xs md:text-sm px-3 md:px-4 py-1.5 md:py-2 border-2 transition-colors tracking-widest ${filter === f.id ? 'bg-[#f5a623] text-[#1a0e05] border-[#1a0e05] shadow-[2px_2px_0_#1a0e05]' : 'border-[#5a3418] text-[#d8b887] hover:border-[#f5a623] hover:text-[#ffc968]'}`}>
            {f.label}
          </button>
        ))}
        <span className="ml-auto font-osd text-[#8b6a3e] text-xs md:text-sm self-center">
          {items.length} / {works.length} ITEMS
        </span>
      </div>

      <div className="grid gap-4 md:gap-5" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 380px), 460px))', justifyContent: 'center' }}>
        {items.map((item, i) => (
          <MediaCard key={item.id} item={item} kind={item.type} onOpen={setSelected} index={i} />
        ))}
      </div>
      <Lightbox item={selected} kind={selected?.type} onClose={() => setSelected(null)} />
    </div>
  );
}
